const STATUS = {
  ORDER_PENDING: "pending",
  ORDER_CONFIRM: "confirm",
  ORDER_SUCCESS: "success",
  ORDER_CANCELED: "canceled",
  ORDER_READY: "ready",
  ORDER_PICKUP: "pickup",
  ORDER_SHIPPING: "shipping",
  ORDER_DELIVERED: "delivered",
  ORDER_REFUNDED: "refunded",

  PAYMENT_NOT_PAID: "0",
  PAYMENT_PAID: "1",
  PAYMENT_ERROR: "2",
  PAYMENT_PENDING: "3",

  SHIPPING_PENDING: "pending",
  SHIPPING_READY: "ready",
  SHIPPING_PICKUP: "pickup",
  SHIPPING_SHIPPING: "shipping",
  SHIPPING_DELIVERED: "delivered",

  SHIPPING_VNFARM: "vnfarm",
  SHIPPING_GHTK: "ghtk",
};

export default STATUS;
